<template>
    <div v-if="page_ready">
        <el-card class="profile position-relative">
            <div class="position-absolute" style="right: 20px;top: 20px;">
                <el-tag effect="light" type="primary"><i class="el-icon-edit"></i>
                    <b>{{ $route.params.id ? ('# ' + $route.params.id) : '新建' }}</b></el-tag>
                <el-tag effect="light" type="danger" v-if="single.host_id != user.user_id && single.id > 0" class="ml-2">
                    <i class="el-icon-user-solid"></i> <b>{{single.host_name}}</b></el-tag>
                <el-tag class="ml-2" effect="light" type="warning" v-if="single.is_recurrent"><i
                    class="el-icon-refresh-right"></i> 循环
                </el-tag>
                <el-tag class="ml-2" effect="light" :type="approveType"><i :class="approveIcon"></i>
                    {{ single.approve_status || '草稿' }}
                </el-tag>
            </div>
            <el-form :model="single" ref="MeetingForm" label-width="100px">
                <el-tabs v-model="edit_tab">
                    <el-tab-pane label="会议信息" name="1">
                        <div class="mt-3">
                            <el-row :gutter="20">
                                <el-col :span="16">
                                    <el-form-item
                                        prop="room_groups"
                                        label="会议室组:">
                                        <el-select v-model="single.group_id" placeholder="请选择会议室组" class="w-100">
                                            <el-option
                                                v-for="item in allRoomGroups"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        prop="usage"
                                        label="用途:" v-if="!invisible">
                                        <el-select v-model="single.usage" placeholder="填写用途" class="w-100">
                                            <el-option
                                                v-for="item in preset.app.usages"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="16">
                                    <el-form-item
                                        prop="topic"
                                        label="主题:"
                                        :rules="[{ required: true, message: '请输入主题', trigger: 'blur' }]">
                                        <el-input v-model="single.topic"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        prop="password"
                                        label="密码:">
                                        <div class="d-flex">
                                            <el-input v-model="single.password" clearable
                                                      placeholder="6位纯数字"></el-input>
                                            <el-button size="" @click="makeRandomPassword" class="ml-2"
                                                       icon="el-icon-magic-stick">生成
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20" type="flex">
                                <el-col>
                                    <el-form-item prop="meeting_date" label="日期:"
                                                  :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                                        <el-date-picker class="w-100"
                                                        v-model="single.meeting_date"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        :disabled="!canAdd"
                                                        placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item
                                        prop="meeting_time"
                                        label="时间:"
                                        :rules="[{ required: true, message: '请输入时间', trigger: 'blur' }]">
                                        <el-time-select class="w-100"
                                                        :disabled="!canAdd"
                                                        placeholder="时间"
                                                        v-model="single.meeting_time"
                                                        :picker-options="{start: '00:00',step: '00:30',end: '23:30',}">
                                        </el-time-select>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item
                                        prop="duration"
                                        label="时长:"
                                        value-format="HH-mm-ss"
                                        :rules="[{ required: true, message: '请输入时长', trigger: 'blur' }]">
                                        <div class="d-flex">
                                            <el-select v-model="single.duration" placeholder="请选择" class="w-100"
                                                       :disabled="!canAdd">
                                                <el-option
                                                    v-for="item in duration_options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20" type="flex" v-if="allow_recurrent_book">
                                <el-col>
                                    <el-form-item prop="meeting_date" label="周期会议:">
                                        <el-switch :inactive-value="0" :active-value="1" v-model="single.is_recurrent"  :disabled="!!single.id"></el-switch>
                                        <div class="float-right ml-3" v-if="!!single.is_recurrent">
                                            {{ single.recurrent_times ? '结束按次数计算' : '结束按日期计算' }}
                                            <el-switch :inactive-value="0" :active-value="1" :disabled="!!single.recurrent_id"
                                                       v-model="single.recurrent_times"></el-switch>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item v-if="single.recurrent_times"
                                                  label="循环次数:">
                                        <el-input-number class="w-100"
                                                         v-model="single.end_meeting_times"
                                                         type="number"
                                                         :disabled="!!single.recurrent_id"
                                                         :max="200"
                                                         :min="2"
                                                         placeholder="选择循环次数">
                                        </el-input-number>
                                    </el-form-item>
                                    <el-form-item v-else
                                                  label="结束日期:">
                                        <el-date-picker class="w-100"
                                                        v-model="single.end_meeting_date"
                                                        type="date"
                                                        :disabled="!!single.recurrent_id"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item
                                        prop="repeat_type"
                                        label="重复周期:">
                                        <el-select v-model="single.repeat_type" placeholder="请选择" class="w-100"
                                                   :disabled="!single.is_recurrent || !!single.recurrent_id">
                                            <el-option v-for="x in repeat_options" :key="x.value" :label="x.name"
                                                       :value="x.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="空闲时间:">
                                <meeting-freebusy ref="meeting_busy"
                                                  :h323="single.option_h323"
                                                  :jump="canAdd"
                                                  @change='handleFreeChange'
                                                  :date="single.meeting_date"
                                                  :id="single.id"
                                                  :group="single.group_id"
                                                  :duration="single.duration"
                                                  :time="single.meeting_time">
                                </meeting-freebusy>
                            </el-form-item>

                            <el-row :gutter="20">
                                <el-col :span="16">
                                    <el-row>
                                        <el-form-item
                                            prop="description"
                                            label="描述:">
                                            <el-input type="textarea" v-model="single.description" :rows="2"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row :gutter="5" type="flex" v-if="!$organization.use_label">
                                        <el-col class="flex-grow-1">
                                            <div class="el-form-item">
                                                <label class="el-form-item__label"
                                                       style="width: 100px;color: #2196f3">参会者:
                                                </label>
                                                <div class="el-form-item__content" style="margin-left: 100px;">
                                                    <div class="el-textarea">
                                                        <div class="el-textarea__inner"
                                                             style="min-height: 60px;">
                                                            <div v-for="item in emails" :key="item.emails"
                                                                 style="display: inline-block">
                                                                <el-tooltip effect="light" :content="item.email"
                                                                            placement="top">
                                                                    <div class="attendee-block">
                                                                        {{ item.name }}
                                                                        {{
                                                                            item.over ? ('&lt;' + item.email + '&gt;') : ''
                                                                        }}
                                                                        <div class="icon-button"
                                                                             @click="removeEmail(item)"><i
                                                                            class="fa fa-times-circle"></i></div>
                                                                    </div>
                                                                </el-tooltip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-col>
                                        <el-col class="flex-grow-0" style="width: 60px;">
                                            <button style="width: 100%;height: 60px" type="button"
                                                    class="btn btn-secondary"
                                                    @click="handleAddressBook">
                                                <i class="fa fa-address-book-o"></i>
                                            </button>
                                        </el-col>
                                    </el-row>
                                    <mh-label-select v-model="single.label"></mh-label-select>

                                </el-col>
                                <el-col :span="8">
                                    <el-row type="flex" style="flex-wrap: wrap">
                                        <el-form-item style="margin-bottom: 0"
                                                      prop="waiting_room"
                                                      label="等候室:">
                                            <el-tooltip class="item" effect="light" content="参会者默认进入会议等候室"
                                                        placement="top">
                                                <el-switch v-model="single.waiting_room"
                                                           @change="single.option_jbh = single.waiting_room?0:single.option_jbh"
                                                           :active-value="1"
                                                           :inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0"
                                                      prop="option_jbh"
                                                      label="提前参会:">
                                            <el-tooltip class="item" effect="light" content="在主持人之前加入会议"
                                                        placement="top">
                                                <el-switch v-model="single.option_jbh"
                                                           @change="single.waiting_room = single.option_jbh?0:single.waiting_room"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0 ;display: none;"
                                                      prop="option_mute"
                                                      label="静音入会:">
                                            <el-tooltip class="item" effect="light" content="参会者进入会议后默认静音"
                                                        placement="top">
                                                <el-switch v-model="single.option_mute"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0"
                                                      prop="option_interpreter"
                                                      label="开启同传:">
                                            <el-tooltip class="item" effect="light" content="激活后，开启同传。主持人入会可以设置"
                                                        placement="top">
                                                <el-switch v-model="single.option_interpreter"
                                                           :disabled="!!(single && single.id && isTencentMeeting)"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting"
                                                      prop="option_live"
                                                      label="开启直播:">
                                            <el-tooltip class="item" effect="light" content="激活后，创建直播链接"
                                                        placement="top">
                                                <el-switch v-model="single.option_live"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting && !$organization.hide_option_internal"
                                                      prop="option_sso_only"
                                                      label="仅内部用户:">
                                            <el-tooltip class="item" effect="light" content="激活后，仅内部用户可参会"
                                                        placement="top">
                                                <el-switch v-model="single.option_sso_only"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting"
                                                      prop="option_water_mark"
                                                      label="启用水印:">
                                            <el-tooltip class="item" effect="light" content="激活后，启用分享水印"
                                                        placement="top">
                                                <el-switch v-model="single.option_water_mark"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item style="margin-bottom: 0"
                                                      v-if="isTencentMeeting && $organization.allow_enroll"
                                                      prop="option_enroll"
                                                      label="开启报名:">
                                            <el-tooltip class="item" effect="light" content="开启报名后，只有参会名单上的用户才可以入会"
                                                        placement="top">
                                                <el-switch v-model="single.option_enroll"
                                                           @change="handleEnrollOptionChange"
                                                           active-value="1"
                                                           inactive-value="0">
                                                </el-switch>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-tooltip class="item" effect="light"
                                                    content="请选择录制方式，如自动录制则主持人与会后自动录制，但使用主持密码则无效"
                                                    placement="top">
                                            <fake-form-item :width="20">
                                                <el-select v-model="single.auto_record" size="small"
                                                           style="width: 125px;" class="type-primary"
                                                           placeholder="选择录像方案">
                                                    <el-option label="手动选择录制" :value="0"></el-option>
                                                    <el-option label="自动本地录制" :value="1"></el-option>
                                                    <el-option label="自动云端录制" :value="2"></el-option>
                                                </el-select>
                                            </fake-form-item>
                                        </el-tooltip>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row>
                            <div class="line"></div>
                            <div style="display: flex; align-items: center;justify-content: space-between;">
                                <div>
                                    <el-button :loading="is_loading" class="mt-3 ml-2" type="primary"
                                               @click="handleSubmit">
                                        {{ need_approval ? '提交申请' : '保存修改' }}
                                    </el-button>
                                    <el-button :loading="is_loading" class="mt-3" type="default"
                                               @click="$router.go(-1)">
                                        返回我的会议
                                    </el-button>
                                </div>
                                <div class="flex-grow-1 ml-3 mr-5">
                                    <div style="padding-top: 18px;text-align: left;" class="date-time-reminder"
                                         v-show="need_approval">
                                        <i class="fa fa-info"></i> 参会人可在:{{ join_meeting_at }} 入会, 系统将会在:{{
                                            end_meeting_at
                                        }} 强制结束会议
                                        <br/>
                                        <template v-if="!invisible">
                                            <i class="fa fa-info"></i>
                                            {{ single.id ? '注意:修改日期和时间以及时长，将需要重新审批。' : '会议申请保存后将提交给管理员审批' }}
                                        </template>
                                    </div>
                                </div>
                                <div class="">
                                    <el-checkbox v-model="single.quite" style="padding-top: 20px;">
                                        {{ !single.quite ? '自动发邮件通知参会者' : '自动发邮件通知参会者' }}
                                    </el-checkbox>
                                </div>
                            </div>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="报名管理" name="2" v-if="single.option_enroll==1">
                        <el-row :gutter="20">
                            <el-col>
                                <div class="el-form-item mb-0">
                                    <label class="el-form-item__label"
                                           style="width: 100px;">参会链接:
                                    </label>
                                    <div class="el-form-item__content" style="margin-left: 100px;">
                                        <a :href="this.single.join_url" target="_blank">{{this.single.join_url || '未创建' }}</a>
                                    </div>
                                </div>
                            </el-col>
                            <el-col>
                                <div class="el-form-item">
                                    <label class="el-form-item__label"
                                           style="width: 100px;color: #2196f3">特批名单:
                                    </label>
                                    <div class="el-form-item__content" style="margin-left: 100px;">
                                        <el-input type="textarea" v-model="single.enroll_attendees" :rows="2"
                                                  placeholder="请输入报名人员ID，或者手机号。用英文逗号或者回行分割"></el-input>
                                    </div>
                                </div>
                            </el-col>
                            <el-col>
                                <el-button :loading="is_loading" class="mt-1 ml-2" type="primary"
                                           icon="el-icon-document-checked"
                                           @click="handleSubmitEnroll" size="small">
                                    上传特批名单
                                </el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <el-divider content-position="left"></el-divider>
                                <el-form :inline="true" @submit.native.prevent size="small">
                                    <el-form-item>
                                        <el-button type="success" size="small" plain icon="el-icon-refresh"
                                                   :loading="is_loading" @click="loadEnrollData">查看报名数据
                                        </el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input size="small" clearable v-model="enroll_search.search"
                                                  prefix-icon="el-icon-search"
                                                  :placeholder="('搜索')"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" size="small" plain icon="el-icon-check"
                                                   :loading="is_loading" @click="approveEnroll(3)">批准选中报名
                                        </el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="danger" size="small" plain icon="el-icon-check"
                                                   :loading="is_loading" @click="approveEnroll(2)">拒绝选中报名
                                        </el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="warning" size="small" plain icon="el-icon-close"
                                                   :loading="is_loading" @click="approveEnroll(1)">取消选中报名
                                        </el-button>
                                    </el-form-item>
                                    <el-form-item class="pull-right">
                                        <el-button type="success" size="small" plain icon="el-icon-download"
                                                   @click="exportEnrollData">导出报名数据
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table
                                    size="mini"
                                    :data="enrollDataFiltered"
                                    border stripe
                                    :default-sort="{prop: 'meeting_time', order: 'descending'}"
                                    empty-text="请点击 查看报名数据 从腾讯会议官网下载报名清单"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange"
                                >
                                    <el-table-column
                                        type="selection"
                                        width="55"></el-table-column>
                                    <el-table-column prop="enroll_id" label="报名id" width="100" sortable
                                    ></el-table-column>
                                    <el-table-column prop="nick_name" label="昵称" width="120" sortable
                                    ></el-table-column>
                                    <el-table-column prop="status" label="报名状态" width="90"
                                                     :filters="[
                                                     { text: '未审核', value: '1' },
                                                     { text: '已拒绝', value: '2' },
                                                     { text: '已批准', value: '3' }
                                                     ]"
                                                     :filter-method="tableFilterHandler"
                                                     :filter-multiple="false"
                                                     filter-placement="bottom-end">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status==1">未审核</span>
                                            <span v-if="scope.row.status==2">已拒绝</span>
                                            <span v-if="scope.row.status==3">已批准</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="enroll_time" label="报名时间" width="180"
                                                     sortable></el-table-column>
                                    <el-table-column prop="userid" label="用户id" width="100" sortable></el-table-column>
                                    <el-table-column prop="enroll_source_type" label="报名来源" width="100"
                                                     :filters="[
                                                     { text: '用户手动报名', value: '1' },
                                                     { text: '批量导入报名', value: '2' },
                                                     ]"
                                                     :filter-multiple="false"
                                                     :filter-method="tableFilterHandler"
                                                     filter-placement="bottom-end">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.enroll_source_type==1">用户手动报名</span>
                                            <span v-else>批量导入报名</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-for="x in enroll_question_list" :key="x.id" :label="x.question">
                                        <template slot-scope="scope">
                                            {{ scope.row | enrollAnswer(x.question) }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="嘉宾管理" name="2" v-if="single.option_sso_only==1">
                        <el-row :gutter="20">
                            <el-col>
                                <div class="el-form-item mb-2 el-form-item__label">
                                    请在下面输入框中输入嘉宾信息，每行一个嘉宾信息，格式为：<span class="text-info">嘉宾手机号码 嘉宾姓名</span> , 可以不用输入嘉宾姓名。
                                </div>
                            </el-col>
                            <el-col>
                                <div class="el-form-item">
                                    <label class="el-form-item__label"
                                           style="width: 100px;color: #2196f3">嘉宾名单:
                                    </label>
                                    <div class="el-form-item__content" style="margin-left: 100px;">
                                        <el-input type="textarea" v-model="single.meeting_guests" :rows="5"
                                                  placeholder="嘉宾手机号码 嘉宾姓名 用回行分割"></el-input>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
        </el-card>
        <address-book-picker :edit_mode="address_book_visible" :address_book="emails" @cancel="handleCancel"
                             @success="handleSuccess">
        </address-book-picker>
        <table ref="excel_table" style="max-height: 1px; overflow: hidden;visibility: hidden">
            <thead>
            <tr>
                <th>报名id</th>
                <th>昵称</th>
                <th>报名状态</th>
                <th>报名时间</th>
                <th>用户id</th>
                <th>报名来源</th>
                <th>手机号</th>
                <th>邮箱</th>
                <th>姓名</th>
                <th>公司名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(x,index) in enroll_data" :key="index">
                <td>{{ x.enroll_id }}</td>
                <td>{{ x.nick_name }}</td>
                <td>
                    <span v-if="x.status==1">未审核</span>
                    <span v-if="x.status==2">已拒绝</span>
                    <span v-if="x.status==3">已批准</span>
                </td>
                <td>{{ x.enroll_time }}</td>
                <td>{{ x.userid }}</td>
                <td>
                    <span v-if="x.enroll_source_type==1">用户手动报名</span>
                    <span v-if="x.enroll_source_type==2">批量导入报名</span>
                </td>
                <td>{{ x | enrollAnswer('手机号') }}</td>
                <td>{{ x | enrollAnswer('邮箱') }}</td>
                <td>{{ x | enrollAnswer('姓名') }}</td>
                <td>{{ x | enrollAnswer('公司名称') }}</td>

            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import MeetingFreebusy from "../components/Meeting-FreeBusy";
import AddressBookPicker from "../components/address-book-picker";
import editMixin from "../common/mixins/front-edit-mixin";
import FakeFormItem from "@/components/fake-form-item.vue";
import MhLabelSelect from "../components/mh-label-select.vue";


export default {
    name: "edit",
    mixins: [editMixin],
    components: {MhLabelSelect, AddressBookPicker, MeetingFreebusy, FakeFormItem: FakeFormItem},
}
</script>

<style lang="scss">
.date-time-reminder {

    font-size: 13px;
    color: #0288D1;
    text-align: right;
}

.meeting-time-reminder {
    color: #0288D1;
    font-size: 13px;
    position: absolute;
    right: 10px;
    bottom: 5px;
}

.el-button.appendix {
    height: 28px;
    margin-top: 5px;
}
</style>
